import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export class Platter extends React.Component {
    render() {
        const platterTextBlock = props => {
            return {
                en: (
                    <section className="platters-textblock">
                        <h1>
                            Celebrate <nobr>with a platter.</nobr>
                        </h1>
                        <p>
                            Fill your plate and heart with one of our delicious
                            platters.
                        </p>
                        <p className="subtitle">
                            Please order at least 24 hours in advance.
                        </p>
                    </section>
                ),
                es: (
                    <section className="platters-textblock">
                        <h1>
                            Una bandeja de comida{' '}
                            <nobr>para cada celebración.</nobr>
                        </h1>
                        <p>
                            Llena tu corazón con nuestras deliciosas bandejas de
                            comida.
                        </p>
                        <p className="subtitle">
                            Por favor ordena las bandejas con al menos 24 horas
                            de anticipación.
                        </p>
                    </section>
                )
            };
        };

        const platterButton = props => {
            return {
                en: <button className="button">Explore Platters</button>,
                es: (
                    <button className="button">
                        Ver Bandejas<sup>*</sup>
                    </button>
                )
            };
        };

        const platterButtonDisclaimer = props => {
            return {
                en: '',
                es: (
                    <p className="subtitle">
                        <sup>*</sup>Al presionar este enlace serás dirigido a
                        una página en inglés.
                    </p>
                )
            };
        };

        return (
            <section id="platters" className="to-blur">
                <Container>
                    <Row>
                        <Col xs={7} md={6} className="platters-block">
                            {platterTextBlock()[this.props.langKey]}
                            <a
                                href="https://www.publix.com/shop-online/in-store-pickup/platters-and-boxes/2542ef78-b49e-4ca2-a576-809b187f1673"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {platterButton()[this.props.langKey]}
                            </a>
                            {platterButtonDisclaimer()[this.props.langKey]}
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default Platter;
